/*
  DogPure · enlaces del menú móvil hacia secciones de la portada.
  Dawn solo cierra el panel si recibe el elemento al que devolver el foco; aquí se le pasa
  el botón del menú, se libera el bloqueo de desplazamiento y se lleva al visitante a la sección.
*/
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-dp-menu-link]');
  if (!link) return;

  const drawer = link.closest('dp-header-drawer');
  const summary = drawer && drawer.querySelector('summary');
  if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, summary);
  }

  const url = new URL(link.href, window.location.href);
  if (url.pathname !== window.location.pathname || !url.hash) return;

  const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  if (!target) return;

  event.preventDefault();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.requestAnimationFrame(() => {
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (window.location.hash !== url.hash) history.pushState(null, '', url.hash);
    const heading = target.querySelector('h2') || target;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  });
});

/*
  Estado accesible del botón del menú: Dawn solo actualiza aria-expanded al cerrar con teclado.
  Se sincroniza con el atributo [open] del panel y la etiqueta cambia entre «Menú» y «Cerrar menú».
  Además, menú y búsqueda nunca quedan abiertos a la vez.
*/
(() => {
  const drawer = document.querySelector('dp-header-drawer');
  const details = drawer && drawer.querySelector('details');
  const summary = details && details.querySelector('summary');
  if (!details || !summary) return;

  const sync = () => {
    const open = details.hasAttribute('open');
    summary.setAttribute('aria-expanded', String(open));
    const label = open ? summary.dataset.labelClose : summary.dataset.labelOpen;
    if (label) summary.setAttribute('aria-label', label);
  };
  new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
  sync();

  const searchModal = document.querySelector('details-modal.header__search');
  const searchDetails = searchModal && searchModal.querySelector('details');

  // Al abrir el menú, cerrar la búsqueda
  new MutationObserver(() => {
    if (details.hasAttribute('open') && searchDetails?.hasAttribute('open')) searchModal.close(false);
  }).observe(details, { attributes: true, attributeFilter: ['open'] });

  // Al abrir la búsqueda, cerrar el menú
  if (searchDetails) {
    new MutationObserver(() => {
      if (searchDetails.hasAttribute('open') && details.hasAttribute('open')) {
        drawer.closeMenuDrawer(new Event('close'), summary);
        searchModal.querySelector('input[type="search"]')?.focus();
      }
    }).observe(searchDetails, { attributes: true, attributeFilter: ['open'] });
  }
})();
